import { templates as templates$1 } from "../locales/de.js";
import { deTemplates } from "@progressive-development/pd-page";
import { deTemplates as deTemplates$1 } from "@progressive-development/pd-dialog";
import { deTemplates as deTemplates$2 } from "@progressive-development/pd-wizard";
import { deTemplates as deTemplates$3 } from "@progressive-development/pd-content";
import { deTemplates as deTemplates$4 } from "@progressive-development/pd-forms";
import { deTemplates as deTemplates$5 } from "@progressive-development/pd-order";
//#region src/generated/locale-wrapper/de-wrapper.ts
var templates = {
	...templates$1,
	...deTemplates$1,
	...deTemplates$5,
	...deTemplates$2,
	...deTemplates,
	...deTemplates$3,
	...deTemplates$4
};
//#endregion
export { templates };
